import { Society, SocietyCorporateId } from 'types/Society';
import { configsByCorporateId } from '../config/configsByCorporateId';

const globalCorporateId = process.env.REACT_APP_UI_CORPORATE_ID;

export const getConfigByCorporateId = (society?: Society) => {
  const corporateId = (globalCorporateId ||
    society?.corporateId ||
    SocietyCorporateId.DEFAULT) as SocietyCorporateId;

  return configsByCorporateId[corporateId];
};
